import { FormReportTypes, IFormReportAction } from './formReport.type';

export const getForm = (): IFormReportAction => ({
	type: FormReportTypes.GET_FORM,
});
